import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { Shield, Save, User } from 'lucide-react';
import api from '../../api/axios';
import styles from './Settings.module.css';

const Settings = () => {
  const [passwordForm, setPasswordForm] = useState({ current: '', newPass: '', confirm: '' });
  const [loading, setLoading] = useState(false);

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    if(passwordForm.newPass !== passwordForm.confirm) {
      toast.error("Passwords do not match!");
      return;
    }

    try {
      setLoading(true);
      const payload = new FormData();
      payload.append('currentPassword', passwordForm.current);
      payload.append('password', passwordForm.newPass);

      await api.put('/users/profile', payload, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      
      toast.success("Security Password updated successfully!");
      setPasswordForm({ current: '', newPass: '', confirm: '' });
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to update password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.pageHeader}>
        <div>
          <h1>Security Settings</h1>
          <p>Manage security account credentials</p>
        </div>
      </div>

      <div className={styles.contentGrid}>
        <div className={styles.column}>
          <div className={styles.card}>
            <div className={styles.cardHeader}>
              <Shield size={20} className={styles.icon} />
              <h2>Change Password</h2>
            </div>
            <div className={styles.cardBody}>
              <form onSubmit={handlePasswordSubmit} className={styles.passwordForm}>
                <div className={styles.inputGroup}>
                  <label>Current Password</label>
                  <input type="password" value={passwordForm.current} onChange={e => setPasswordForm({...passwordForm, current: e.target.value})} required />
                </div>
                <div className={styles.inputGroup}>
                  <label>New Password</label>
                  <input type="password" value={passwordForm.newPass} onChange={e => setPasswordForm({...passwordForm, newPass: e.target.value})} required />
                </div>
                <div className={styles.inputGroup}>
                  <label>Confirm New Password</label>
                  <input type="password" value={passwordForm.confirm} onChange={e => setPasswordForm({...passwordForm, confirm: e.target.value})} required />
                </div>
                <button type="submit" className={styles.saveBtn} disabled={loading}>
                  <Save size={16} /> {loading ? 'Updating...' : 'Update Password'}
                </button>
              </form>
            </div>
          </div>
        </div>

        <div className={styles.column}>
          <div className={styles.card}>
            <div className={styles.cardHeader}>
              <User size={20} className={styles.icon} />
              <h2>Profile Details</h2>
            </div>
            <div className={styles.cardBody}>
              <div className={styles.inputGroup}>
                <label>Assigned Post</label>
                <input type="text" value="Main Gate - Shift 1" disabled />
              </div>
              <div className={styles.inputGroup}>
                <label>Agency Contact</label>
                <input type="text" value="+91 99999 88888" disabled />
              </div>
              <small className={styles.helperText}>Contact Admin to change profile details.</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
